<ng-container *transloco="let t">
  @let hasAnalysis = !!((sadmEntityId || sadmEntityDraft) && analysisFormAnswer);
  @if (isLoading() || hasAnalysis) {
    <div
      appearance="outline"
      class="flex-wrap items-center!"
      tuiCardLarge
      tuiCell="l"
      [attr.data-testid]="isLoading() ? 'analysis-skeleton' : null">
      @if (isLoading()) {
        <ng-container [ngTemplateOutlet]="summarySkeleton" />
        <div class="h-8 w-16 rounded-full" [tuiSkeleton]="true"></div>
        <div class="h-8 w-24 rounded-full" [tuiSkeleton]="true"></div>
      } @else {
        @if (summary$ | async; as summary) {
          @if (summary.previewUri && !hasPreviewError()) {
            <img
              class="size-12 shrink-0 rounded-lg object-cover"
              data-testid="analysis-preview"
              [alt]="summary.title"
              [src]="summary.previewUri"
              (error)="hasPreviewError.set(true)" />
          } @else {
            <div class="size-12 shrink-0 overflow-hidden rounded-lg" data-testid="analysis-preview-placeholder">
              <pxc-image-broken />
            </div>
          }
          <span class="select-none" tuiTitle>
            <span class="font-medium" data-testid="analysis-title">{{ summary.title }}</span>
            @if (summary.subtitle) {
              <span data-testid="analysis-subtitle" tuiSubtitle>{{ summary.subtitle }}</span>
            }
          </span>
        } @else {
          <ng-container [ngTemplateOutlet]="summarySkeleton" />
        }
        <div class="flex shrink-0 gap-2 max-md:w-full max-md:justify-center">
          <button
            appearance="outline"
            data-testid="analysis-edit-button"
            size="s"
            tuiButton
            type="button"
            (click)="editAnalysis()">
            {{ t('Éditer') }}
          </button>
          <button
            appearance="outline-destructive"
            data-testid="analysis-delete-button"
            size="s"
            tuiButton
            type="button"
            (click)="deleteAnalysis()">
            {{ t('Supprimer') }}
          </button>
        </div>
      }
    </div>
  } @else {
    <div class="flex flex-col gap-2">
      <button
        appearance="secondary"
        class="self-start"
        data-testid="analysis-create-button"
        iconEnd="@tui.plus"
        tuiButton
        type="button"
        (click)="addAnalysis()">
        {{ t('Ajouter une analyse') }}
      </button>
    </div>
  }

  <ng-template #summarySkeleton>
    <div class="flex min-w-0 flex-1 items-center gap-4" data-testid="analysis-summary-skeleton">
      <div class="size-12 shrink-0 rounded-lg" [tuiSkeleton]="true"></div>
      <div class="flex flex-1 flex-col gap-2">
        <div class="h-4 w-1/2 rounded-sm" [tuiSkeleton]="true"></div>
        <div class="h-3 w-1/4 rounded-sm" [tuiSkeleton]="true"></div>
      </div>
    </div>
  </ng-template>
</ng-container>
